module.exports = __webpack_public_path__ + "img/GAME_NUMBER2.3b6788c2.jpg";